import { SIDEBAR_DEVICE_DETAIL_KEY } from "fleet/constant/sidebar";
import { playerVersionsOptionsSelector } from "fleet/redux-store/ui-state/player-versions/selectors";
import { tagsOptionsSelector } from "fleet/redux-store/ui-state/tags/selectors";
import { connect } from "react-redux";
import { storesReady } from "redux-store";
import { getAuthUser } from "redux-store/auth";
import { getConnDeviceStatus } from "redux-store/connection/selectors";
import {
  deviceWithStatusSelector,
  makeFullDeviceWithStatusSelector,
} from "redux-store/derivative-selectors";
import {
  fullDevicesLoadAction,
  fullDevicesUnloadAction,
} from "redux-store/ui-state/full-devices/actions";
import { fullDevicesStateSelector } from "redux-store/ui-state/full-devices/selectors";
import {
  hideSidebarAction,
  setActiveKeySidebarAction,
} from "redux-store/ui-state/sidebar";
import { isVenueSyncEnabled } from "redux-store/users";
import { getFilterOptions } from "ui/filter/utils";

import { FullDeviceListTable } from "./full-device-list-table";

const fullDeviceWithStatusSelector = makeFullDeviceWithStatusSelector();

function mapStateToProps(state) {
  const storesLoaded = storesReady(
    state.global.devices,
    state.pages.fullDevices,
    state.pages.playerVersions,
    state.pages.tags,
  );
  const user = getAuthUser(state);
  const venueSyncEnabled = isVenueSyncEnabled(user);

  return {
    storesLoaded,
    venueSyncEnabled,
    devices: deviceWithStatusSelector(state),
    deviceStatusOnline: getConnDeviceStatus(state),
    fullDevicesState: fullDevicesStateSelector(state),
    fullDevices: fullDeviceWithStatusSelector(state),
    // Filter component uses string match
    playerVersionsOptions: getFilterOptions(
      playerVersionsOptionsSelector(state),
    ),
    tagsOptions: getFilterOptions(tagsOptionsSelector(state)),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchDevices: (params, options) => {
      return new Promise((resolve, reject) => {
        dispatch(
          fullDevicesLoadAction({
            resolve,
            reject,
            serviceArgs: {
              options,
              params,
            },
          }),
        );
      });
    },
    showSidebar: (device) => {
      dispatch(
        setActiveKeySidebarAction(
          SIDEBAR_DEVICE_DETAIL_KEY,
          device.name,
          device,
          null,
        ),
      );
    },
    hideSidebar: () => {
      dispatch(hideSidebarAction);
    },
    unloadDevices: () => {
      dispatch(fullDevicesUnloadAction);
    },
  };
}

const ConnectedFullDeviceListTable = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FullDeviceListTable);

export { ConnectedFullDeviceListTable };
